import { Behavior } from './Behavior';
import { ContentType, LessonMode, QuestionFeedbackState, isFullCreditScore, questionFeedbackFromScores } from '../../Constants';
import UtilsService from '../services/UtilsService';
import questionFeedbackManager from '../managers/QuestionFeedbackManager';


export class StandaloneAlchemieItemBehavior extends Behavior {
  pendingInteractiveMessageByLessonElementId = new Map();

  mustMessageParent = () => {
    return false;
  }

  requiresExplicitSubmitOnNavigation = () => true;

  clearInteractiveMessageSession = (lessonElementId) => {
    this.pendingInteractiveMessageByLessonElementId.delete(lessonElementId);
  }

  holdInteractiveMessage = (lessonElementId, data) => {
    this.pendingInteractiveMessageByLessonElementId.set(lessonElementId, data);
    return true;
  }

  flushInteractiveMessage = (lessonElementId, responseAnswer, model) => {
    if (!this.pendingInteractiveMessageByLessonElementId.has(lessonElementId)) {
      return false;
    }
    const pending = this.pendingInteractiveMessageByLessonElementId.get(lessonElementId);
    this.setResponseData(pending, responseAnswer, model);
    this.pendingInteractiveMessageByLessonElementId.delete(lessonElementId);
    return true;
  }

  //keep this function suspect it will needed in a near future revision
  //
  goalFromConfiguration = (data) => {
    if (data === undefined || data === null) {
      return '';
    }
    if (this.isValidJSON(data)) {
      const dataJson = JSON.parse(data);
      if (dataJson.endState !== undefined && dataJson.endState !== null) {
        return dataJson.endState;
      }
      return '';
    }
    return data;
  }

  getMessage = (responseAnswer) => {
    return null;
  }

  checkForValidResponse = (responseAnswer, model) => {
    const lessonElementId = responseAnswer?.lessonElementId ?? model?.lessonElementId;
    const pending = lessonElementId != null
      ? this.pendingInteractiveMessageByLessonElementId.get(lessonElementId)
      : undefined;
    const goal = pending !== undefined
      ? pending
      : responseAnswer.goal;
    if (goal === null || goal === undefined || String(goal).trim() === '') {
      return false;
    }
    return true;
  }

  isAutoScored = (model) => {
    const autoScore = (ContentType.getAutoscore(model.type) &&
      !model.survey && !model.unscored);

    return autoScore;
  }

  setResponseData = (data, responseAnswer, model) => {
    responseAnswer.goal = (data)?data:'';
  }

  isValidJSON = (str) =>   {
    // Reject non-strings and empty strings immediately
    if (typeof str !== 'string' || str.trim() === '') {
      return false;
    }
  
    try {
      const parsed = JSON.parse(str);
      
      // Ensure the output is an object or array (ignores numbers, booleans, and null)
      return typeof parsed === 'object' && parsed !== null;
    } catch (error) {
      return false;
    }
  }

  getInitializedResponse = (lessonElementId) => {
    const responseAnswer = {
      goal: '',
      lessonElementId,
      isCorrect: false
    };
    return responseAnswer;
  }

  getCorrectAnswersText = (model) => {
    return '<div></div>';
  }

  setCorrectAnswer = (state, model) => {
    const temp = {
      goal: model.validation.answers[0].goal,
      lessonElementId: model.lessonElementId,
      isCorrect:true
    };
    state.setCurrentResponse(UtilsService.safeMobxClone(temp));
  }

  resetStudentAnswer = (state) => {
    if (state?.cachedResponseAnswer) {
      this.clearInteractiveMessageSession(state.cachedResponseAnswer.lessonElementId);
      state.setCurrentResponse(UtilsService.safeMobxClone(state.cachedResponseAnswer));
    }
  }

  /// ///
  // model = content model
  //
  getQuestionFeedbackText = (model, correctFeedback, incorrectFeedback, correctFeedbackBody, incorrectFeedbackBody, mode, questionIsCorrect, currentAttemptCount, { lessonElementState }) => {
    let textBody = '';
    if (mode === LessonMode.PREVIEW || mode === LessonMode.ITEM_PREVIEW || mode === LessonMode.STUDENT_PREVIEW || mode === LessonMode.PUBLISHER_PREVIEW) {
      textBody += UtilsService.previewWarning();
    } else {
      if (typeof currentAttemptCount !== 'undefined' && currentAttemptCount !== -1 && currentAttemptCount > 1) {
        //textBody += UtilsService.saveWarning();
      } else {
        textBody += UtilsService.saveCommit();
      }
    }

    let textHeader = '';
    let attemptsText = '';
    
    // Add attempts remaining text for practice mode when answer is incorrect or partially correct
    if (questionFeedbackManager.isPractice && 
        (questionIsCorrect === QuestionFeedbackState.INCORRECT || questionIsCorrect === QuestionFeedbackState.PARTIAL_CORRECT) &&
        model.lessonElementId) {
      attemptsText = questionFeedbackManager.getAttemptsRemainingText(model.lessonElementId);
    }

    if (questionIsCorrect === QuestionFeedbackState.CORRECT) {
      textHeader = correctFeedback;
      if (correctFeedbackBody) {
        textBody = `${correctFeedbackBody} ${textBody}`;
      }
    } else if (questionIsCorrect === QuestionFeedbackState.PARTIAL_CORRECT) {
      textHeader = `${UtilsService.partiallyCorrect()}`;
      let custom = '';
      if (incorrectFeedbackBody) {
        custom = `${incorrectFeedbackBody } `;
      }

      textBody = `${UtilsService.partiallyCorrectPrompt()}. <br/>${ custom }${textBody}`;
    } else {
      textHeader = incorrectFeedback;
      if (incorrectFeedbackBody) {
        textBody = `${incorrectFeedbackBody} ${textBody}`;
      }
    }

    // Add attempts text after the header if it exists
    if (attemptsText) {
      textHeader += attemptsText;
    }

    let finalText = '<div class=\'question-feedback-header\'>';
    finalText += textHeader;
    finalText += '</div>';
    finalText += '<div class=\'question-feedback-body\'>';
    finalText += textBody;
    finalText += '</div>';

    return finalText;
  }

  isAnswerCorrect = (answerId, lessonElementState, model) => {
    if (lessonElementState.correctAnswerShowing) {
      return true;
    }

    return lessonElementState.isScored && isFullCreditScore(lessonElementState.submittedItemScore, lessonElementState.maxScore);
  }

  isQuestionCorrect = (lessonElementState, lessonElementId) => {
    if (!lessonElementState) {
      return QuestionFeedbackState.INCORRECT;
    }

    return questionFeedbackFromScores(lessonElementState.submittedItemScore, lessonElementState.maxScore);
  }

} 

export default new StandaloneAlchemieItemBehavior();